var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div dias-cloak=\"vm.loading\" cloak-msg=\"'Daten des Berichts werden geladen'\"><header class=\"page-title header-detail\"><div vueinit props=\"{ tab_kbez: vm.tableau.tab_kbez }\"><page-tab-title v-bind:placeholder=\"'_PAGE_TITLE_TABLEAU_{{tab_kbez}}_'\" v-bind:extra=\"propsAngular\"></page-tab-title></div><h1>Bericht</h1><h2>{{ vm.tableau.tab_kbez }}</h2></header><section class=\"main col-lg-12\"><dias-report report=\"{{ vm.tableau.tab_bericht }}\" height=\"{{ vm.tableau.tab_hoehe }}\"></dias-report></section></div>");;return buf.join("");
}